/** The standalone (cursor) input bar's placeholder. */
export default {
  askAgentAnything: " · ask {name} anything",
  continueLead: "Continue ",
  typeMessage: "Type a message…",
} as const;
